import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const twoCardsBlockFields = `
  _id,
  _type,
  title,
  subTitle,
  items[]{
    _type,
    body[],
    image {
      ${imageFields}
    },
    backgroundColor
  }
`

export const TWO_CARDS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "two-cards-block"][0]{
    ${twoCardsBlockFields}
  }
`)
